<template>
  <md-list>
    <md-list-item>
      <md-autocomplete v-model="name" :md-options="names" autocomplete="no" @md-selected="nameSelected">
        <label>Name</label>
      </md-autocomplete>
    </md-list-item>
    <md-list-item>
      <md-autocomplete v-model="city" :md-options="cities" autocomplete="no" @md-selected="citySelected">
        <label>City</label>
      </md-autocomplete>
    </md-list-item>
    <md-divider></md-divider>
    <md-list-item>
      <md-field>
        <label for="medium">Medium</label>
        <md-select v-model="medium" name="medium" id="medium" multiple>
          <md-option :value="medium" v-for="medium in mediums" :key="medium">{{ medium }}</md-option>
        </md-select>
      </md-field>
    </md-list-item>
  </md-list>
</template>

<script>
export default {
  props: {
    names: Array,
    cities: Array,
    mediums: Array
  },
  data () {
    return {
      name: null,
      city: null,
      medium: null
    }
  },
  watch: {
    medium (selectedMediums, oldSelectedMediums) {
      if (selectedMediums && selectedMediums.length !== 0) {
        this.$emit('selectedMediums', selectedMediums)
        this.name = ''
        this.city = ''
      } else if (oldSelectedMediums && oldSelectedMediums.length !== 0 && (!selectedMediums || selectedMediums.length === 0)) {
        this.$emit('selectedMediums', [])
      }
    }
  },
  methods: {
    nameSelected (selectedName) {
      this.$emit('selectedName', selectedName)
      if (this.city) { this.city = '' }
      if (!this.medium || this.medium.length !== 0) { this.medium = null }
    },
    citySelected (selectedCity) {
      this.$emit('selectedCity', selectedCity)
      if (this.name) { this.name = '' }
      if (!this.medium || this.medium.length !== 0) { this.medium = null }
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 900px) {
  .md-drawer.md-permanent-card {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12) !important;
    position: relative !important;
    border-radius: 2px !important;
    transition: .3s cubic-bezier(.4,0,.2,1) !important;
    transition-property: color,background-color !important;
    will-change: color,background-color !important;
    margin: 8px !important;
    z-index: 1 !important;
  }
}
@media (max-width: 900px) {
  .md-drawer.md-permanent-card {
    display: none;
  }
}
</style>
